import { createAction } from 'redux-actions';

export const resetItemsAndPackagesSkus = createAction(
  'RESET_INVENTORY_ITEMS_AND_PACKAGES_SKUS'
);

export const updateItemsAndPackagesSkusSearchQuery = createAction(
  'UPDATE_INVENTORY_ITEMS_AND_PACKAGES_SKUS_SEARCH_QUERY'
);
